<template>
	<div class="pui-form">
		<mgrupajeequipamiento-modals :modelName="modelName"></mgrupajeequipamiento-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mgrupajeequipamiento-form-header
				:modelPk="modelPk"
			></mgrupajeequipamiento-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDGRUEQUI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idgruequi-mgrupajeequipamiento`"
									v-model="model.idgruequi"
									:label="$t('mgrupajeequipamiento.idgruequi')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODGRUEQUEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codgruequedi-mgrupajeequipamiento`"
									v-model="model.codgruequedi"
									:label="$t('mgrupajeequipamiento.codgruequedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md8>
								<pui-text-field
									:id="`name-mgrupajeequipamiento`"
									v-model="model.name"
									:label="$t('mgrupajeequipamiento.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="100"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mgrupajeequipamiento`"
									v-model="model.fecbaja"
									:label="$t('mgrupajeequipamiento.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mgrupajeequipamientoActions from './MgrupajeequipamientoActions';
import mgrupajeequipamientoModals from './MgrupajeequipamientoModals.vue';

export default {
	name: 'mgrupajeequipamiento-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mgrupajeequipamiento-modals': mgrupajeequipamientoModals
	},
	data() {
		return {
			modelName: 'mgrupajeequipamiento',
			actions: mgrupajeequipamientoActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mgrupajeequipamiento');
		}
	},
	created() {}
};
</script>
